import { render, staticRenderFns } from "./reo-market-product-matrix.vue?vue&type=template&id=1e46fb5b&scoped=true&"
import script from "./reo-market-product-matrix.vue?vue&type=script&lang=js&"
export * from "./reo-market-product-matrix.vue?vue&type=script&lang=js&"
import style0 from "./reo-market-product-matrix.vue?vue&type=style&index=0&id=1e46fb5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e46fb5b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e46fb5b')) {
      api.createRecord('1e46fb5b', component.options)
    } else {
      api.reload('1e46fb5b', component.options)
    }
    module.hot.accept("./reo-market-product-matrix.vue?vue&type=template&id=1e46fb5b&scoped=true&", function () {
      api.rerender('1e46fb5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/result-components/reo_table/reo-market-product-matrix.vue"
export default component.exports